import { __decorate } from "tslib";
import { mixins } from 'vue-class-component';
import { Component, Prop } from 'vue-property-decorator';
import DiyMixin from '@/helpers/vue_mixins/v2/DiyMixin';
import ShippingForm from '@/components/v2/ShippingForm.vue';
import ShippingMethodInitialQuery from '@/plugins/graphql/queries/v2/diy/shipping-method.gql';
import ShippingUpdateMixin from '@/helpers/vue_mixins/v2/ecommerce/ShippingUpdateMixin';
import { ShippingMethodModel } from '@/helpers/entities/models/ShippingMethodModel';
import UpdateAppAllowAdvanceOrder from '@/plugins/graphql/mutations/v2/update-app-allow-advance-order.gql';
let ShippingMethodInitial = class ShippingMethodInitial extends mixins(DiyMixin, ShippingUpdateMixin) {
    get queryOnFlight() {
        return this.$apollo.queries.shippingMethod.loading;
    }
    get header() {
        return 'SHIPPING';
    }
    get caption() {
        return 'Add Shipping Method';
    }
    updateAllowAdvanceOrder(allowAdvanceOrder) {
        this.$apollo.mutate({
            mutation: UpdateAppAllowAdvanceOrder,
            variables: {
                input: {
                    appUuid: this.appUuid,
                    allowAdvanceOrder,
                },
            },
        });
    }
};
__decorate([
    Prop({ type: String, required: true })
], ShippingMethodInitial.prototype, "appUuid", void 0);
__decorate([
    Prop({ type: String, required: false })
], ShippingMethodInitial.prototype, "plan", void 0);
__decorate([
    Prop({ type: String, required: false })
], ShippingMethodInitial.prototype, "advanceOrder", void 0);
ShippingMethodInitial = __decorate([
    Component({
        components: {
            ShippingForm,
        },
        apollo: {
            shippingMethod: {
                query: ShippingMethodInitialQuery,
                variables() {
                    const { appUuid } = this;
                    return {
                        appUuid,
                    };
                },
                update(data) {
                    return new ShippingMethodModel(data.shippingMethodInitial);
                },
            },
        },
    })
], ShippingMethodInitial);
export default ShippingMethodInitial;
